export default __webpack_public_path__ + "static/media/mask_icon_white_mob.126c00a1.png";